module.exports = "/assets/59edef4e4f82095b0f2db787d200807f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HX.png
// module id = 1455
// module chunks = 0